<div class="checklist-control-row">
    <!-- Label Section -->
    <label class="checklist-control-label">
        {{ lineItem().name }}
        @if (lineItem().isRequired) {
            <span class="required-indicator">*</span>
        }
        <button pButton icon="pi pi-volume-up" [text]="true" (click)="speakLabel()" class="speak-button"></button>
    </label>

    <!-- Control Section -->
    <div class="checklist-control-input">
        <div class="digital-signature-container" [class.digital-signature-container--error]="hasError()">
            <!-- Existing Signatures List -->
            @if (signatures.length > 0) {
                <div class="signatures-list">
                    @for (signature of signatures; track $index) {
                        <div class="signature-item">
                            <div class="signature-details">
                                <div class="signature-info">
                                    <span class="signed-by">Signed by {{ signature.signerName }}</span>
                                    <span class="signed-datetime">on {{ formatDateTime(signature) }} from {{ signature.deviceOwner }}'s device</span>
                                </div>
                                <div class="signature-text-display">
                                    {{ signature.signatureText }}
                                </div>
                                <button pButton
                                    icon="pi pi-times"
                                    [rounded]="true"
                                    [text]="true"
                                    severity="danger"
                                    (click)="removeSignature($index)"
                                    [disabled]="disabled()"
                                    class="remove-signature-btn"
                                    pTooltip="Remove signature"
                                    tooltipPosition="top">
                                </button>
                            </div>
                        </div>
                    }
                </div>
            }

            <!-- Add Signature Button -->
            <button pButton type="button" label="Add signature" icon="pi pi-plus" [text]="true"
                    class="add-signature-button" (click)="menu.toggle($event)" #menuButton
                    [disabled]="disabled()">
            </button>

            <!-- Add Signature Menu -->
            <p-menu #menu [model]="addSignatureMenu()" [popup]="true" appendTo="body"></p-menu>
        </div>
        @if (hasError()) {
            @for (err of errors(); track $index) {
                <small class="p-error d-block">{{ err }}</small>
            }
        }
    </div>
</div>

<!-- Signature Modal Dialog -->
<p-dialog header="Add signature" [modal]="true" [(visible)]="showSignatureModal" [style]="{ width: '35rem' }">
    <p class="signing-as-text">You are signing as <strong>{{ getCurrentSigningAs() }}</strong>.</p>
    <div class="grid">
        <div class="col-12">
            <label for="signatureName" class="block text-900 font-medium mb-2">Type your name to sign</label>
            <input type="text" pInputText id="signatureName" [(ngModel)]="signatureText"
                class="w-full signature-input" placeholder="Enter your name" autofocus />
        </div>
        @if (signatureText() || signingAsOtherPerson()) {
            <div class="col-12">
                <label class="block text-900 font-medium mb-2">Electronic signature:</label>
                <div class="signature-preview">
                    {{ signatureText() || '' }}
                </div>
            </div>
        }
    </div>
    <div class="flex justify-end gap-2 mt-4">
        <p-button label="Cancel" severity="secondary" (click)="cancelSignature()" />
        <p-button label="Sign" (click)="addSignature()" [disabled]="!signatureText().trim()" />
    </div>
</p-dialog>
